export const WEBSITE = {
    DOMAIN : 'www.yourcybersentinel.com'
}